<template>
  <div class="stockList print-font">
    <div class="title print-font">备货清单</div>
    <div class="body print-font">
      <div class="table-title">按主订单</div>
      <el-table class="orderDetailTable" :data="orderDetailTableData" border style="width: 100%">
        <el-table-column prop="created_at" label="推送时间" width="130">
        </el-table-column>
        <el-table-column prop="out_ware_day" label="要求发货日">
        </el-table-column>
        <el-table-column prop="main_number" label="主订单号">
        </el-table-column>
        <el-table-column prop="order_number" label="子订单号" width="120">
        </el-table-column>
        <el-table-column prop="user_name" label="客户">
        </el-table-column>
        <el-table-column prop="ruigu_code" label="锐锢编码">
        </el-table-column>
        <el-table-column prop="self_code" label="三方编码">
        </el-table-column>
        <el-table-column prop="name" label="商品名称" width="280">
        </el-table-column>
        <el-table-column prop="amount" label="订购数量">
        </el-table-column>
        <el-table-column prop="mo_statusName" label="状态">
        </el-table-column>
      </el-table>
      <div class="table-title">按商品信息</div>
      <el-table :data="orderGoodsInfoData" border style="width: 100%">
        <el-table-column type="index" label="序号">
        </el-table-column>
        <el-table-column prop="ruigu_code" label="锐锢编码">
        </el-table-column>
        <el-table-column prop="self_code" label="三方编码">
        </el-table-column>
        <el-table-column prop="name" label="商品名" width="240">
        </el-table-column>
        <el-table-column prop="total_amount" label="数量">
        </el-table-column>
        <el-table-column prop="out_ware_day" label="要求发货日">
        </el-table-column>
      </el-table>
      <div class="btns">
        <el-button type="primary" size="small" @click="myPrint">打印</el-button>
        <el-button type="primary" size="small" @click="exportExcel">导出</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import { getOdStatusList, currentTime } from '@/utils/utils'
import { getBigorderStockListing } from '@/models/orderModel'
export default {
  data () {
    return {
      orderDetailTableData: [],
      orderGoodsInfoData: []
    }
  },
  mounted () {
    this.getStockListing()
  },
  methods: {
    exportExcel () {
      let wb = XLSX.utils.table_to_book(document.querySelector('.orderDetailTable'))
      /* get binary string as output */
      for (let i in wb.Sheets.Sheet1) {
        if (i.indexOf('A') !== -1) {
          wb.Sheets.Sheet1[i].z = 'yyyy/m/d h:mm:ss'
        } else if (i.indexOf('B') !== -1 && i.indexOf('1') === -1) {
          wb.Sheets.Sheet1[i].v = parseInt(wb.Sheets.Sheet1[i].v)
        } else if (i.indexOf('C') !== -1 || i.indexOf('D') !== -1 || i.indexOf('F') !== -1) {
          wb.Sheets.Sheet1[i].z = '0'
        }
      }
      let wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array'
      })
      try {
        let fileName = currentTime() + '.xlsx'
        FileSaver.saveAs(
          new Blob([wbout], {
            type: 'application/octet-stream'
          }),
          fileName
        )
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, wbout)
      }
      return wbout
    },
    async getStockListing () {
      let params = {
        order_type:1
      //   order_ids: this.$route.query.id
      }
      let data = await getBigorderStockListing(params)
      this.orderDetailTableData = data.order
      this.orderGoodsInfoData = data.goods
      for (let i of data.order) {
        i.mo_statusName = getOdStatusList().mo_statusList.filter(item => item.value === i.mo_status)[0].label
      }
    },
    myPrint () {
      let subOutputRankPrint = document.querySelector('.stockList')
      let newContent = subOutputRankPrint.innerHTML
      let oldContent = document.body.innerHTML
      document.body.innerHTML = newContent
      window.print()
      window.location.reload()
      document.body.innerHTML = oldContent
      return false
    }
  }
}
</script>

<style lang="scss">
.stockList {
  padding: 10px;
  .title {
    text-align: center;
    font-weight: bold;
  }
  .body {
    .table-title {
      height: 30px;
      width: 80px;
      margin-right: 1px;
      margin-top: 15px;
      border-radius: 8px 8px 0px 0px;
      background-color: rgb(239, 239, 239);
      font-size: 14px;
      text-align: center;
      line-height: 30px;
    }
  }
  .btns {
    margin-top: 20px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/bigorder/stockList.vue